import { DataFormUserProps } from 'types/DataFormUserProps';
import { isValidEmail, isValidPassword } from 'utils/functions';
import { UserMondelezProps } from 'types/UserProps';
import { RolesTypes } from 'types/RolesTypes';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { apiAxiosAuth } from 'services/api';

export function verifyForm(
	dataForm: DataFormUserProps,
	handleNotify: any,
	userToEdit: null | UserMondelezProps
) {
	if (dataForm.firstName === '') {
		handleNotify('Preencha o primeiro nome do usuário', 'error');
		return false;
	}

	if (dataForm.lastName === '') {
		handleNotify('Preencha o sobrenome do usuário', 'error');
		return false;
	}

	if (dataForm.typeUser === '') {
		handleNotify('Insira um tipo de usuário', 'error');
		return false;
	}

	if (dataForm.phone === '') {
		handleNotify('Preencha o telefone do usuário', 'error');
		return false;
	}

	if (!isValidEmail(dataForm.email)) {
		handleNotify('Insira um email válido', 'error');
		return false;
	}

	if (!isValidEmail(dataForm.email)) {
		handleNotify('Insira um email válido', 'error');
		return false;
	}

	if (dataForm.password === '' || dataForm.passwordConfirm === '') {
		handleNotify('Preencha os campos de senha', 'error');
		return false;
	}

	if (dataForm.password !== dataForm.passwordConfirm) {
		handleNotify('As duas senhas precisam ser iguais', 'error');
		return false;
	}

	if (userToEdit === null && !isValidPassword(dataForm.password)) {
		handleNotify(
			'A senha deve conter no minimo 8 caracteres, letras maiuscula e minuscula, incluir numeros e caracteres especiais',
			'error',
			4000
		);

		return false;
	}

	return true;
}

export function generateListOptionFromRolesList(listRoles: RolesTypes[]) {
	const newList: SelectInputItemProps[] = listRoles.map((item) => ({
		id: item.id,
		option: item.name
	}));
	return newList;
}

export function findRoleInArray(actualRole: string, listRoles: RolesTypes[]) {
	if (typeof actualRole === 'string') {
		const itemFound: RolesTypes[] = listRoles.filter(
			(item) => item.name.toLowerCase() === actualRole.toLowerCase()
		);

		if (itemFound.length > 0) {
			return { id: itemFound[0].id, option: itemFound[0].name };
		}
	}

	return '';
}

const listParaAdd = [
	{
		email: 'leonardo.viana@mdlz.com',
		firstName: 'Leonardo',
		lastName: 'Viana',
		phone: '11987654321',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'tiffany.ferreira2@mdlz.com',
		firstName: 'Tiffany',
		lastName: 'Ferreira2',
		phone: '21998765432',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'rafaeldavid.hushi@mdlz.com',
		firstName: 'Rafaeldavid',
		lastName: 'Hushi',
		phone: '31999887766',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'vanessa.pedrosa@mdlz.com',
		firstName: 'Vanessa',
		lastName: 'Pedrosa',
		phone: '41988776655',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'marcos.silva1@mdlz.com',
		firstName: 'Marcos',
		lastName: 'Silva1',
		phone: '51977665544',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'fabiana.berigo@mdlz.com',
		firstName: 'Fabiana',
		lastName: 'Berigo',
		phone: '61966554433',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'carlos.sales@mdlz.com',
		firstName: 'Carlos',
		lastName: 'Sales',
		phone: '71955443322',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'karina.pardim@mdlz.com',
		firstName: 'Karina',
		lastName: 'Pardim',
		phone: '81944332211',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	},
	{
		email: 'daniela.cedeno@mdlz.com',
		firstName: 'Daniela',
		lastName: 'Cedeno',
		phone: '91933221100',
		password: '@Mondelez123',
		roleId: 'cdbec7a5-bd63-4e7e-9c75-b96eab524bec'
	}
];

export function saveList() {
	listParaAdd.forEach(async (user) => {
		await apiAxiosAuth
			.post('users', user)
			.then(() => {
				console.warn(`Usuário ${user.email} criado com sucesso.`);
			})
			.catch(() => {
				console.warn('✌️error user --->', user);
			});
	});
}
